import { gql, QueryHookOptions } from '@apollo/client';
import { WorkflowType } from 'modules/domains';
import {
  GRAPHQL_TYPENAMES,
  GraphQLResponsePaginationInfo,
  GraphQLTypeNameData,
} from 'modules/graphql';
import {
  DEFAULT_PAGINATION as pagination,
  DEFAULT_SORT_BY as sortBy,
  DEFAULT_SORT_DIRECTION as sortDirection,
} from 'modules/quickActionsMenu/constants';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLVariables } from '../types';

/** Query to return all published and draft journeys */
export const getQuickActionsJourneys = gql`
  query getQuickActionsJourneys($pagination: Pagination, $search: String, $sort: Sort) {
    cmdKJourneys(pagination: $pagination, search: $search, sort: $sort) {
      info {
        count
        offset
        limit
        page
      }
      results {
        id
        enabled
        isArchived
        name
        workflowType
      }
    }
  }
`;

export type GraphQLJourney = {
  id: number;
  enabled: boolean;
  isArchived: boolean;
  name: string;
  workflowType: WorkflowType;
} & GraphQLTypeNameData<GRAPHQL_TYPENAMES.JOURNEY>;

type QueryJourneysResponse = {
  cmdKJourneys: {
    info: GraphQLResponsePaginationInfo;
    results: GraphQLJourney[];
  };
};

export const useQueryJourneys = (
  search: string,
  options?: QueryHookOptions<QueryJourneysResponse, GraphQLVariables>,
) =>
  useGraphql<QueryJourneysResponse>(getQuickActionsJourneys, {
    ...options,
    notifyOnNetworkStatusChange: true,
    variables: {
      search,
      sort: { sortBy, sortDirection },
      pagination,
    },
  });
